// The `HighlightCategoryTastic` component fetches carousel data based on a specific heading,
// such as "new," from the provided Tastic data. It then passes the relevant carousel content
// to the `HighlightCategorySection` component for rendering. This setup allows for dynamic and
// reusable content display, tailored to the heading's criteria. It leverages a modular approach,
// making it easier to manage and customize category highlights in the UI.

'use client';

import HighlightCategorySection from 'components/commercetools-ui/organisms/content/hightlight-category';
import { TasticProps } from 'frontastic/tastics/types';
import React from 'react';
import { Carousel, CarouselTasticData } from 'types/next';

const NewArrivalsTastic = ({ data }: TasticProps<CarouselTasticData>) => {
  const categoryContent = data?.data?.dataSource?.carousels?.find(
    (content: Carousel) => content?.contentID === data?.contentID,
  ) as Carousel;

  //NewArrivals Layout is same as HighlightCategory Layout , so reusing the component

  return (
    <>
      <HighlightCategorySection content={categoryContent} />
    </>
  );
};

export default NewArrivalsTastic;
